function housingTypeSelect(e) {
    if ($(e).is(':checked')) {
        $(e).prop('checked', true);
    } else {
        $(e).prop('checked', false);
    }

    if ($(e).attr("value") == "M") {
        $('#AptUnitFrom').removeAttr("disabled");
        $('#AptUnitTo').removeAttr("disabled");
    } else {
        $('#AptUnitFrom').attr("disabled", true);
        $('#AptUnitTo').attr("disabled", true);
    }
    UpdateHousingTypeSelection();
};

function UpdateHousingTypeSelection() {
    var $housingTypeSelections = $('#formHousingTypeContainer input#SerializedHousingType:hidden');

    var housingTypeSelections = new Array();
    $('.HousingTypeSelection input:radio:checked').each(function (i, o) {
        housingTypeSelections.push($(o).attr('id') + ':' + $(o).val());
    });
    $housingTypeSelections.val(housingTypeSelections.join('~'));
};

function EnableNoOfApartments() {
    if ($('.HousingTypeSelection :radio:checked').length > 0) {
        if ($('.HousingTypeSelection :radio:checked').attr("value") == "M") {
            $('#AptUnitFrom').removeAttr('disabled');
            $('#AptUnitTo').removeAttr('disabled');
        }
    }
};

$(function () {
    UpdateHousingTypeSelection();
});

